export default {"src":"/_next/static/media/tracxn.aeb7acbb.svg","height":31,"width":171,"blurWidth":0,"blurHeight":0};